/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CashAmount,
  CashAmountFromJSON,
  CashAmountToJSON,
  FetchDirectorFinancialDetailsResponseTutors,
  FetchDirectorFinancialDetailsResponseTutorsFromJSON,
  FetchDirectorFinancialDetailsResponseTutorsToJSON,
  ProgramType,
} from './'

/**
 *
 * @export
 * @interface FetchDirectorFinancialDetailsResponsePrograms
 */
export interface FetchDirectorFinancialDetailsResponsePrograms {
  /**
   *
   * @type ProgramType
   * @memberof FetchDirectorFinancialDetailsResponsePrograms
   */
  programType: ProgramType
  /**
   *
   * @type CashAmount
   * @memberof FetchDirectorFinancialDetailsResponsePrograms
   */
  tutorOwesDirector: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchDirectorFinancialDetailsResponsePrograms
   */
  familyOwesTutor: CashAmount
  /**
   * Number of tutors under the director.
   * @type number
   * @memberof FetchDirectorFinancialDetailsResponsePrograms
   */
  tutorCount: number
  /**
   * Number of families supported by the director's tutors.
   * @type number
   * @memberof FetchDirectorFinancialDetailsResponsePrograms
   */
  familyCount: number
  /**
   * List of tutors under the director.
   * @type {Array<FetchDirectorFinancialDetailsResponseTutors>}
   * @memberof FetchDirectorFinancialDetailsResponsePrograms
   */
  tutors: Array<FetchDirectorFinancialDetailsResponseTutors>
}

export function FetchDirectorFinancialDetailsResponseProgramsFromJSON(
  json: any
): FetchDirectorFinancialDetailsResponsePrograms {
  return FetchDirectorFinancialDetailsResponseProgramsFromJSONTyped(json, false)
}

export function FetchDirectorFinancialDetailsResponseProgramsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchDirectorFinancialDetailsResponsePrograms {
  if (json === undefined || json === null) {
    return json
  }
  return {
    programType: json['programType'],
    tutorOwesDirector: CashAmountFromJSON(json['tutorOwesDirector']),
    familyOwesTutor: CashAmountFromJSON(json['familyOwesTutor']),
    tutorCount: json['tutorCount'],
    familyCount: json['familyCount'],
    tutors: (json['tutors'] as Array<any>).map(
      FetchDirectorFinancialDetailsResponseTutorsFromJSON
    ),
  }
}

export function FetchDirectorFinancialDetailsResponseProgramsToJSON(
  value?: FetchDirectorFinancialDetailsResponsePrograms | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    programType: value.programType,
    tutorOwesDirector: CashAmountToJSON(value.tutorOwesDirector),
    familyOwesTutor: CashAmountToJSON(value.familyOwesTutor),
    tutorCount: value.tutorCount,
    familyCount: value.familyCount,
    tutors: (value.tutors as Array<any>).map(
      FetchDirectorFinancialDetailsResponseTutorsToJSON
    ),
  }
}
